export default "__VITE_ASSET__C5Km7APi__"